module.exports = __webpack_public_path__ + "img/ideation-06-benchmarking-sample-01.7b6fc3d4.jpg";